export const TEMP_SELECTED_PRODUCT_LAST_ID = 999999999;

export enum ProductsSetsPermissions {
  READ_PRODUCTS_SET_DOWNLOAD_BUTTON = 'read_products_set_download_button',
  READ_PRODUCTS_SET_DOWNLOAD_SEPARATELY_BUTTON = 'read_products_set_download_separately_button',
  READ_PRODUCTS_SET_CLEAR_BUTTON = 'read_products_set_clear_button',
  READ_PRODUCTS_SET_COMPOSE_BUTTON = 'read_products_set_compose_button'
}
